<template>
    <sg-phone-change :pre-phone="prePhone" :new-user="true" @done="onDone"
    
    form-message="Продолжив региcтрацию, Вы сможете передавать показания, оплачивать, просматривать архивы квитанций и платежей."
    
     />
</template>

<script>    

    import SgPhoneChange from '../../components/phone/SgPhone'

    export default {
        name: "sg-quick-signup",
        props: {
            prePhone: {
                type: String
            }
        },
        components: { SgPhoneChange },
        methods: {
            onDone() {
                this.$router.push({name: 'quick-pay-downloads', params: { afterReg: true }})
            },
        }
    }
</script>

<style>

</style>